import { getUrl } from '@buffer-mono/shared-utils/bibe'

import { ImageDimensions } from '../constants'

const IMAGE_PROXY_FIT_IN_URL =
  'https://images.buffer.com/dynamic-internal/fit-in'

const MEDIA_BUCKET_HOSTS = new Set([
  'buffer-media-uploads.s3.amazonaws.com',
  'buffer-updates-media-backfill-bucket.s3.amazonaws.com',
])

const GIF_URL = /\.gif(?:$|[?#])/i

export const PROXY_THUMBNAIL_WIDTH = 360

export const isBufferMediaBucketUrl = (url: string): boolean => {
  try {
    return MEDIA_BUCKET_HOSTS.has(new URL(url).hostname)
  } catch {
    return false
  }
}

export const getResizedImageUrlWithWidth = (
  url: string,
  width: number,
): string => {
  return getUrl(`${IMAGE_PROXY_FIT_IN_URL}/${width}x/${url}`)
}

export const getResizedWebpImageUrlWithWidth = (
  url: string,
  width: number,
): string => {
  return getUrl(
    `${IMAGE_PROXY_FIT_IN_URL}/${width}x/filters:format(webp)/${url}`,
  )
}

/** GIFs pass through: the proxy flattens an animated GIF to its first frame. */
export const getProxiedThumbnailUrl = (
  url: string,
  width: number = PROXY_THUMBNAIL_WIDTH,
): string => {
  if (!isBufferMediaBucketUrl(url) || GIF_URL.test(url)) {
    return url
  }

  return getResizedWebpImageUrlWithWidth(url, width)
}

export const getQueueResizedImageUrl = (url: string): string => {
  return getResizedImageUrlWithWidth(url, ImageDimensions.queueImage.width)
}
